import { handleActions } from 'redux-actions';
import { merge, set, unset } from 'lodash';
import * as ActionTypes from '../../constants/ActionTypes';

const labelsSearchDefaults = {
    labels: {
        higherOrder: {},
        originalValue: {},
        currentValue: {},
        changed: false
    }
};
const searchReducer = handleActions(
    {
        [ActionTypes.SET_HIGHERORDER_LABELS_BATCH]: (state, action) => {
            return { ...state, labels: Object.assign({}, state.labels, { higherOrder: action.value }) };
        },
        [ActionTypes.SET_ORIGINALVALUES_LABELS_BATCH]: (state, action) => {
            return { ...state, labels: Object.assign({}, state.labels, { originalValue: action.value }) };
        },
        [ActionTypes.SET_CURRENTVALUE_LABELS_BATCH]: (state, action) => {
            return { ...state, labels: Object.assign({}, state.labels, { currentValue: action.value }) };
        },
        [ActionTypes.DELETE_LABELS_BATCH]: (state, action) => {
            const updatePayload = merge({}, state.labels.currentValue);
            unset(updatePayload, action.key);
            return {
                ...state,
                labels: Object.assign({}, state.labels, { changed: true, currentValue: updatePayload })
            };
        },
        [ActionTypes.UPDATE_CURRENTVALUE_LABELS_BATCH]: (state, action) => {
            const updatePayload = merge({}, state.labels.currentValue);
            set(updatePayload, action.key, action.value);
            return {
                ...state,
                labels: Object.assign({}, state.labels, { changed: true, currentValue: updatePayload })
            };
        },
        [ActionTypes.SAVED_LABELS_BATCH]: (state, action) => {
            return { ...state, labels: Object.assign({}, state.labels, { changed: false }) };
        }
    },
    labelsSearchDefaults
);

export { searchReducer, searchReducer as default };



// WEBPACK FOOTER //
// ./src/reducers/manage/search.js